import React, { useEffect, useRef } from 'react'

// Accessible dialog: closes on Escape / overlay click (unless `busy`) and focuses the dialog on open.
const Modal = ({ title, children, actions, onClose, busy = false }) => {
    const dialogRef = useRef(null)
    const closeRef = useRef(onClose)
    const busyRef = useRef(busy)
    closeRef.current = onClose
    busyRef.current = busy

    useEffect(() => {
        // Respect autoFocus on a field inside the dialog; otherwise focus the dialog itself.
        if (dialogRef.current && !dialogRef.current.contains(document.activeElement)) {
            dialogRef.current.focus()
        }
        const onKey = (e) => { if (e.key === 'Escape' && !busyRef.current) closeRef.current() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [])

    return (
        <div className='mv-modal-overlay' onClick={() => !busy && onClose()}>
            <div className='mv-modal' role='dialog' aria-modal='true' aria-labelledby='mv-modal-title'
                tabIndex={-1} ref={dialogRef} onClick={(e) => e.stopPropagation()}>
                <h2 id='mv-modal-title' className='mv-modal-title'>{title}</h2>
                {children}
                {actions && <div className='mv-modal-actions'>{actions}</div>}
            </div>
        </div>
    )
}

export default Modal
